export const KG_CO2 = 'kg CO₂e'
export const EUR = 'EUR'
export const TONS = 't'
export const KM = "km"
export const KW_H = "kw/h"
export const LITER = "l"